const bodyScrollLock = require('body-scroll-lock');
export const disableBodyScroll = bodyScrollLock.disableBodyScroll;
export const enableBodyScroll = bodyScrollLock.enableBodyScroll;
export const clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks;
export function toggleBodyScroll(target, maxViewport) {
    const body = document.querySelector('body');
    body.classList.toggle('is-locked');
    if (body.classList.contains('is-locked') && maxViewport) {
        if (window.innerWidth < maxViewport) {
            disableBodyScroll(target);
        }
    } else if (body.classList.contains('is-locked') && !maxViewport) {
        disableBodyScroll(target);
    } else {
        clearAllBodyScrollLocks();
    }
}



// WEBPACK FOOTER //
// ./js/util/scrollLock.js